export const THING_PAGE_NS = 'pages/ThingPage';

export const i18n = {
  en: {
    section: {
      untitledSection: 'Untitled Section',
      notAllowedCharacters:
        'The following characters are not allowed: [`_=~!@#$%^&*()+[{]}|;:\'"/,?<.>]/',
    },
    tabs: {
      contents: 'Contents',
      activities: 'Activities',
      navigation: 'Navigation',
    },
    activity: {
      labels: {
        search: 'Search',
        noResult: 'No Result',
      },
      verbs: { created: 'created', edited: 'edited' },
    },
    entityMenu: {
      edit: 'Edit',
      duplicate: 'Duplicate',
      delete: 'Delete',
      confirmDelete: 'Are you sure to delete {{name}}?',
    },
    errorMessage: {
      cannotRenameSection: 'There was an error during section renaming.',
    },
  },
};
